import { render } from "./users-authorization.vue?vue&type=template&id=0eca290b&scoped=true&ts=true"
import script from "./users-authorization.vue?vue&type=script&lang=ts"
export * from "./users-authorization.vue?vue&type=script&lang=ts"

import "./users-authorization.vue?vue&type=style&index=0&id=0eca290b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eca290b"]])

export default __exports__